/**
 * A/B Test Runner — orchestrator.
 * Imports the test registry and cookie utility,
 * initializes all cookies and applies CSS classes to <html>.
 *
 * This file is imported once from the main js/index.js bundle.
 */
import { TESTS } from "./constants.js";
import ABCookies from "./cookies.js";
import "./quick-links.js";
import { applySportLocationVariant } from "./sport-location.js";
// import { applySessionVariant } from "./sessions.js";

// Expose globally for console debugging: ABCookies.get('ab_hero')
window.ABCookies = ABCookies;

// Cleanup of retired A/B tests — remove leftover cookies from everyone's browsers.
['ab_listing_mobile', 'ab_cart', 'ab_sidebar', 'ab_session_search_card', 'ab_camp_distance', 'ab_featured', 'ab_session_schedule', 'ab_hero_home'].forEach((name) => ABCookies.remove(name));

TESTS.forEach((test) => {
  window.abTestSections = window.abTestSections || [];
  if(!window.abTestSections.includes(test.name)) {
    return;
  }

  document.documentElement.classList.add(test.name);

  const value = ABCookies.init(test.name, {
    values: test.values,
    days: test.days,
  });

  if (value === String(test.activeOn)) {
    document.documentElement.classList.add(test.className);
  }

  
});


// Show the correct template variant based on ab_sport_location cookie
// document.addEventListener('DOMContentLoaded', applySportLocationVariant);

// Show the correct session variant based on ab_sessions cookie
// document.addEventListener('DOMContentLoaded', () => {
//   if (document.querySelector('.ab-sessions-variant')) {
//     applySessionVariant();
//   }
// });
